export enum SearchPageSizeLimits {
	Minimum = 24,
	Maximum = 120,
}
